import React from 'react';
import { AreaChart, Area, ResponsiveContainer } from 'recharts';
import { getDatesByMacro } from '../../utils/dates';

const RevenueChart = ({chartData, period}) => {
    //Clean chartData and only keep the populated dates with revenue
    const cleanData = chartData.map(({revenue, date}) => ({revenue, date}));
    //Generate full range of dates for the whole period
    const allDatesForPeriod = period.length === 22 && period.includes('to') ? getDatesByMacro['customRange'](period) : getDatesByMacro[period]();
    //Get clean data format records for all the dates
    const normalizedDates = allDatesForPeriod.map(date => ({date, revenue: 0}))
    //Overwrite the dates where we have data for revenue
    const datesWithRevenue = normalizedDates.map(item => {
      const override = cleanData.find(o => o.date === item.date)
      return override ? { ...item, ...override } : item
    })

    return (
      <div style={{ width: "200px", height: "60px" }}>
        <ResponsiveContainer>
          <AreaChart data={datesWithRevenue}>
            <Area 
              key="1" 
              type="linear" 
              dataKey="revenue" 
              stackId="1" 
              stroke="#1e5d95" 
              fill="#bedaf1ff"
            />
          </AreaChart>
        </ResponsiveContainer>
      </div>
    );
}

export default RevenueChart;